import { ZfIcon, ZfIconButton, ZfListItem, ZfLoadingSpinner, ZfStack } from '@zafire/react';
import type { FunctionComponent, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useAddDocument, useClient, useClientPackages, useDocuments, useRemoveDocument, useUserDetails } from '../../../api';
import { useDownloadDocument } from '../../../api/document-api/queries/use-download-document';

interface IProps {
    documentId: number;
    hasBorderBottom?: boolean;
}

export const Document: FunctionComponent<IProps> = ({ documentId, hasBorderBottom }) => {
    const { i18n } = useTranslation();
    const { data: user } = useUserDetails();
    const { data: client } = useClient();
    const { isDocInCart } = useClientPackages();
    const addDocument = useAddDocument();
    const removeDocument = useRemoveDocument();
    const { data: documents } = useDocuments();
    const downloadDocument = useDownloadDocument();

    if (!documents) {
        return <ZfLoadingSpinner style={{ margin: 'auto' }} />;
    }

    const document = documents?.find((doc) => doc.id === documentId);
    const onDocumentClick = async () => await downloadDocument.mutateAsync(documentId);

    const onCartClick = (e: MouseEvent<HTMLZfIconButtonElement>) => {
        e.stopPropagation();
        (isDocInCart(documentId) ? removeDocument : addDocument).mutateAsync(documentId);
    };

    return (
        <ZfStack
            direction="row"
            justify="space-between"
            key={documentId}
            style={{ borderBottom: hasBorderBottom ? '1px solid var(--border-color-default-normal)' : '' }}
        >
            <ZfListItem titleText={document?.name[i18n.language] ?? ''} size="small" onListItemSelect={onDocumentClick} style={{ flex: 1 }}>
                <ZfIcon slot="leading" name="description" size="medium" />
            </ZfListItem>
            {user?.currentRole === 'RM' && client && (
                <ZfIconButton hierarchy="tertiary" size="medium" onClick={onCartClick}>
                    <ZfIcon size="large" name={isDocInCart(documentId) ? 'check_circle' : 'add_circle'} />
                </ZfIconButton>
            )}
        </ZfStack>
    );
};
